import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import type { PillProps } from '../pill';
import Pill from '../pill';
const SelectedPill = t0 => {
  const $ = _c(8);
  const {
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHaspopup,
    children,
    disabled,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoChevronDown16 color="tertiary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== ariaControls || $[2] !== ariaExpanded || $[3] !== ariaHaspopup || $[4] !== children || $[5] !== disabled || $[6] !== onClick) {
    t2 = <Pill aria-controls={ariaControls} aria-expanded={ariaExpanded} aria-haspopup={ariaHaspopup} disabled={disabled} onClick={onClick} type="button">{children}{t1}</Pill>;
    $[1] = ariaControls;
    $[2] = ariaExpanded;
    $[3] = ariaHaspopup;
    $[4] = children;
    $[5] = disabled;
    $[6] = onClick;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default SelectedPill;